// AWS Amplify configuration
// This will be populated with actual values when the backend is deployed

export const awsConfig = {
  Auth: {
    Cognito: {
      // Amazon Cognito Region
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      
      // Amazon Cognito User Pool ID
      userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
      
      // Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
      
      // Hosted UI configuration (optional)
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_OAUTH_DOMAIN || '',
          scopes: ['email', 'profile', 'openid'],
          redirectSignIn: [process.env.REACT_APP_REDIRECT_SIGN_IN || window.location.origin],
          redirectSignOut: [process.env.REACT_APP_REDIRECT_SIGN_OUT || window.location.origin],
          responseType: 'code' as const
        }
      }
    }
  },
  
  API: {
    REST: {
      TripPlannerAPI: {
        endpoint: process.env.REACT_APP_API_ENDPOINT || '',
        region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      }
    }
  }
};

export default awsConfig;